export const vueBusinessHoursTranslations = {
    'en-AU':{
        switchOpen: '',
        switchClosed: '',
        placeholderOpens: 'Start',
        placeholderCloses: 'End',
        addHours: 'Add hours',
        open: {
            invalidInput: 'Please enter an opening time in the 12 hour format (ie. 08:00 AM). You may also enter "24 hours".',
            greaterThanNext: 'Please enter an opening time that is before the closing time.',
            lessThanPrevious: 'Please enter an opening time that is after the previous closing time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        close: {
            invalidInput: 'Please enter a closing time in the 12 hour format (ie. 05:00 PM). You may also enter "24 hours" or "Midnight".',
            greaterThanNext: 'Please enter a closing time that is after the opening time.',
            lessThanPrevious: 'Please enter a closing time that is before the next opening time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        t24hours: '24 hours',
        midnight: 'Midnight',
        days: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            newYearsEve: 'New Year\'s Eve', // prettier-ignore
            newYearsDay: 'New Year\'s Day', // prettier-ignore
            martinLutherKingJrDay: 'Martin Luther King, Jr. Day',
            presidentsDay: 'Presidents\' Day', // prettier-ignore
            easter: 'Easter',
            memorialDay: 'Memorial Day',
            independenceDay: 'Independence Day',
            fourthOfJuly: '4th of July',
            laborDay: 'Labor Day',
            columbusDay: 'Columbus Day',
            veteransDay: 'Veterans Day',
            thanksgivingDay: 'Thanksgiving Day',
            christmasEve: 'Christmas Eve',
            christmas: 'Christmas',
        }
    },
    'en-GB':{
        switchOpen: '',
        switchClosed: '',
        placeholderOpens: 'Start',
        placeholderCloses: 'End',
        addHours: 'Add hours',
        open: {
            invalidInput: 'Please enter an opening time in the 12 hour format (ie. 08:00 AM). You may also enter "24 hours".',
            greaterThanNext: 'Please enter an opening time that is before the closing time.',
            lessThanPrevious: 'Please enter an opening time that is after the previous closing time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        close: {
            invalidInput: 'Please enter a closing time in the 12 hour format (ie. 05:00 PM). You may also enter "24 hours" or "Midnight".',
            greaterThanNext: 'Please enter a closing time that is after the opening time.',
            lessThanPrevious: 'Please enter a closing time that is before the next opening time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        t24hours: '24 hours',
        midnight: 'Midnight',
        days: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            newYearsEve: 'New Year\'s Eve', // prettier-ignore
            newYearsDay: 'New Year\'s Day', // prettier-ignore
            martinLutherKingJrDay: 'Martin Luther King, Jr. Day',
            presidentsDay: 'Presidents\' Day', // prettier-ignore
            easter: 'Easter',
            memorialDay: 'Memorial Day',
            independenceDay: 'Independence Day',
            fourthOfJuly: '4th of July',
            laborDay: 'Labor Day',
            columbusDay: 'Columbus Day',
            veteransDay: 'Veterans Day',
            thanksgivingDay: 'Thanksgiving Day',
            christmasEve: 'Christmas Eve',
            christmas: 'Christmas',
        }
    },
    'en-US':{
        switchOpen: '',
        switchClosed: '',
        placeholderOpens: 'Start',
        placeholderCloses: 'End',
        addHours: 'Add hours',
        open: {
            invalidInput: 'Please enter an opening time in the 12 hour format (ie. 08:00 AM). You may also enter "24 hours".',
            greaterThanNext: 'Please enter an opening time that is before the closing time.',
            lessThanPrevious: 'Please enter an opening time that is after the previous closing time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        close: {
            invalidInput: 'Please enter a closing time in the 12 hour format (ie. 05:00 PM). You may also enter "24 hours" or "Midnight".',
            greaterThanNext: 'Please enter a closing time that is after the opening time.',
            lessThanPrevious: 'Please enter a closing time that is before the next opening time.',
            midnightNotLast: "Midnight can only be selected for the day's last closing time."
        },
        t24hours: '24 hours',
        midnight: 'Midnight',
        days: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            newYearsEve: 'New Year\'s Eve', // prettier-ignore
            newYearsDay: 'New Year\'s Day', // prettier-ignore
            martinLutherKingJrDay: 'Martin Luther King, Jr. Day',
            presidentsDay: 'Presidents\' Day', // prettier-ignore
            easter: 'Easter',
            memorialDay: 'Memorial Day',
            independenceDay: 'Independence Day',
            fourthOfJuly: '4th of July',
            laborDay: 'Labor Day',
            columbusDay: 'Columbus Day',
            veteransDay: 'Veterans Day',
            thanksgivingDay: 'Thanksgiving Day',
            christmasEve: 'Christmas Eve',
            christmas: 'Christmas',
        }
    },
    'uk-UA':{
        switchOpen: '',
        switchClosed: '',
        placeholderOpens: 'Початок',
        placeholderCloses: 'Завершення',
        addHours: 'Додати години',
        open: {
            invalidInput: 'Будь ласка, введіть час відкриття в 12-годинному форматі (наприклад, 08:00 AM). Ви також можете ввести "24 години".',
            greaterThanNext: 'Будь ласка, введіть час відкриття, який є раніше часу закриття.',
            lessThanPrevious: 'Будь ласка, введіть час відкриття, який є після попереднього часу закриття.',
            midnightNotLast: 'Північ можна вибрати лише для останнього часу закриття дня.'
        },
        close: {
            invalidInput: 'Будь ласка, введіть час закриття в 12-годинному форматі (наприклад, 05:00 PM). Ви також можете ввести "24 години" або "Північ".',
            greaterThanNext: 'Будь ласка, введіть час закриття, який є після часу відкриття.',
            lessThanPrevious: 'Будь ласка, введіть час закриття, який є перед наступним часом відкриття.',
            midnightNotLast: 'Північ можна вибрати лише для останнього часу закриття дня.'
        },
        t24hours: '24 години',
        midnight: 'Північ',
        days: {
            monday: 'Понеділок',
            tuesday: 'Вівторок',
            wednesday: 'Середа',
            thursday: 'Четвер',
            friday: 'П\'ятниця',
            saturday: 'Субота',
            sunday: 'Неділя',
            newYearsEve: 'Вечір Нового Року',
            newYearsDay: 'Перший день Нового Року',
            martinLutherKingJrDay: 'День Мартина Лютера Кінга-молодшого',
            presidentsDay: 'День президентів',
            easter: 'Великдень',
            memorialDay: 'День пам\'яті',
            independenceDay: 'День незалежності',
            fourthOfJuly: '4 липня',
            laborDay: 'День праці',
            columbusDay: 'День Колумба',
            veteransDay: 'День ветеранів',
            thanksgivingDay: 'День подяки',
            christmasEve: 'Вечір Різдва',
            christmas: 'Різдво'
        }
    }
}